export enum UserRole {
  Teacher = 'teacher',
  Student = 'student',
  Anonymous = 'anonymous',
}
